import React, { Component } from 'react'
import './Contact.css'

class Contact extends Component {
	componentDidMount() {
		document.title = 'Contact'
	}
	render() {
		return (
			<div className="Contact">
				<h2 className="Contact-header"> Get in Touch </h2>
				<button 
					className="Contact-btn btn btn-orange" 
					href="mailto:vishal.91@live.com?Subject=Hello" 
					target="_top">
						Say Hello
					</button>
			</div>
		)
	}
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js